import React from 'react';

import './BackDrop.scss';

const BackDrop = ({click, breakpoints='backdrop-for-all'}) =>
    <div className={`backdrop ${breakpoints}`} onClick={click} />;

export default BackDrop;